import { Cadence } from "../../../../lib/proto/time";
import { get_age } from "../../../../lib/time";
import { getUserInfo } from "../../../dashboard/user/actions";
import { isEmptyObj, roundNumber } from "../../../helper/helpers";
import { getPotentialIRR } from "../actions";
import { CADENCE, CADENCE_TO_ID, DEFAULT_IRR } from "../constants/constants";

const getContributions = (contributions) => {
    let contribution = contributions;
    let cadence = CADENCE_TO_ID[Cadence.annually.id];

    if(!contributions) {
        contribution = 0;

        return { contribution, cadence };
    }

    if(typeof contributions === 'object' && !isEmptyObj(contributions)) {
        // need to check isEnabled
        if(!contributions.enabled) {
            contribution = 0;
            return { contribution, cadence };
        }

        contribution = roundNumber((contributions.amt_cents / 100), 2);
        cadence = CADENCE_TO_ID[contributions.cadence];
        
        // overwrittern with cadence anually as default
        // should use line 28 when we want to implement feature to edit cadence 
        cadence = CADENCE.ANNUALLY;

        return { contribution, cadence };
    }

    return { contribution, cadence };
}

export const getContribution = (contributionItem) => {
    const { contribution } = getContributions(contributionItem);
    return contribution;
}

export const getCadence = (contribution) => {
    const { cadence } = getContributions(contribution);
    return cadence;
}

export const parseFormat = (initialPortfolioValue) => {
    // if it throws error that means value is already number
    // remove all , and $ from value
    const regex = /[,$]/g;
    return parseFloat(initialPortfolioValue.replace(regex, ""), 10);
}

const formatPercentageRateToDecimal = (rate) => {
    return parseFloat(rate / 100);
}

export const getInterestRate = (interestRate) => {
    return formatPercentageRateToDecimal(interestRate);
}

export const getDistributionRate = (distributionRate) => {
    return formatPercentageRateToDecimal(distributionRate);
}

// doesn't look like we need metaDataItem Logic so far for the formulas we have
const getStartDate = (metaDataItem) => {
    const startDate = metaDataItem && metaDataItem.start_date;
    if(startDate) {
        const [yyyy, mm, dd] = startDate.split("-");
        return mm + "/" + dd + "/" + yyyy;
    }

    const today = new Date();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    const year = today.getFullYear();
    
    return `${month}/${day}/${year}`;
}

export const getUserAge = (dateOfBirth) => {
    return get_age(dateOfBirth, getStartDate());
}

export const formatFixedDecimalPlaces = (value, decimalPlace) => {
    const multiplier = Math.pow(10, decimalPlace);
    return Math.round(value * multiplier) / multiplier;
}

export const handleValueLabelChange = (value) => {
    if(!value) return '0';

    return value;
}

export const handleDollarValueLabelChange = (value) => {
    if(!value) return '$0';
    
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(value);
}

export const handlePercentValueLabelChange = (value) => {
    if(!value) return '0%';

    return `${value}%`;
}

export const removeLeadingZeros = (value) => {
    const newValue = value.replace(/^0+(?!\.)/, '');
    return newValue;
}

const fetchUserInfo = async (token, onBoardingToken, accountIndex, username) => {
    const response = await getUserInfo(token, onBoardingToken, accountIndex, undefined, username);
    return response;
}

const fetchIRR = async (token, accountIndex, username) => {
    const queryParams = new URLSearchParams({ username, accountIndex });
    const response = await getPotentialIRR(token, queryParams)

    if(!response.payload) {
        return DEFAULT_IRR;
    }

    return response.payload;
}

export const fetchChartInfo = async (token, onBoardingToken, accountIndex, username) => {
    try {
        const [userData, irr] = await Promise.all([
            fetchUserInfo(token, onBoardingToken, accountIndex, username),
            fetchIRR(token, accountIndex, username)
        ]);

        return { userData, irr};
    } catch (error) {
        console.log(error);
        throw error;
    }
}